// In-memory map from media_id to a locally-created blob URL for the File
// that was just uploaded. Lets the capture screen render a preview without
// round-tripping through S3. Post-handoff (different tab/device), the cache
// is empty and consumers fall back to fetching a presigned GET URL via
// getOneReportMedia.

const cache = new Map<string, string>();

export function setPreviewCache(mediaId: string, file: Blob): string {
  const existing = cache.get(mediaId);
  if (existing) return existing;
  const url = URL.createObjectURL(file);
  cache.set(mediaId, url);
  return url;
}

export function getPreviewCache(mediaId: string): string | undefined {
  return cache.get(mediaId);
}

export function clearPreviewCache(mediaId: string): void {
  const url = cache.get(mediaId);
  if (url) {
    URL.revokeObjectURL(url);
    cache.delete(mediaId);
  }
}
